<h2 class="dialog-title" mat-dialog-title
  >{{ data.title | translate }} <strong class="dialog-title-suffix">{{ textData.titleSuffix }}</strong>
</h2>
@if (textData.content || textData.contentSuffix) {
  <mat-dialog-content>
    @if (textData.content) {
      <p [innerHTML]="textData.content | translate"></p>
    }

    @if (textData.contentSuffix) {
      <p>
        <strong class="dialog-content-suffix">{{ textData.contentSuffix | translate }}</strong>
      </p>
    }
    @if ($any([Annoyance.fifteen, Annoyance.typing]).includes(data.annoying)) {
      <hr />
      <p>{{ 'dialog.post-fragment.annoyances.puzzleWarning' | translate }}</p>
    }
    @switch (data.annoying) {
      @case (Annoyance.fifteen) {
        <div class="game flex justify-content-center">
          <app-fifteen-game
            [options]="{
              width: 3,
              height: 3
            }"
            (won)="winAnnoyance()"
          ></app-fifteen-game>
        </div>
      }
      @case (Annoyance.typing) {
        <div class="game flex justify-content-center"> </div>
        <app-typing-game (won)="winAnnoyance()"></app-typing-game>
      }
    }
  </mat-dialog-content>
}
<mat-dialog-actions>
  @if (textData.options) {
    @if (textData.options.cancel) {
      <button mat-stroked-button class="dialog-cancel-button" (click)="onCancel()">
        {{ textData.options.cancel | translate }}
      </button>
    }
    @if (textData.options.confirm) {
      <button
        mat-flat-button
        class="dialog-confirm-button"
        (click)="onConfirm()"
        [disabled]="!confirmButtonEnabled"
        cdkFocusInitial
      >
        {{ textData.options.confirm | translate }}
      </button>
    }
  }
</mat-dialog-actions>
